(function () {
  function initGallery(root) {
    var gallery = root.querySelector('[data-zava-gallery]');
    if (!gallery) return;

    var imgs = Array.prototype.slice.call(gallery.querySelectorAll('[data-zava-gallery-img]'));
    var thumbs = gallery.querySelectorAll('[data-zava-gallery-thumb]');
    var prev = gallery.querySelector('[data-zava-gallery-prev]');
    var next = gallery.querySelector('[data-zava-gallery-next]');
    var zoom = gallery.querySelector('[data-zava-gallery-zoom]');
    var stage = gallery.querySelector('[data-zava-gallery-stage]');
    var lightbox = gallery.querySelector('[data-zava-lightbox]');
    var current = 0;

    function show(index) {
      if (!imgs.length) return;
      current = (index + imgs.length) % imgs.length;
      imgs.forEach(function (img, i) {
        img.classList.toggle('is-active', i === current);
      });
      thumbs.forEach(function (btn) {
        btn.classList.toggle('is-active', Number(btn.getAttribute('data-zava-gallery-thumb')) === current);
      });
      syncLightbox();
    }

    function showByMediaId(mediaId) {
      if (mediaId == null || mediaId === '') return false;
      var idStr = String(mediaId);
      var matchIndex = -1;
      imgs.forEach(function (img, i) {
        if (String(img.getAttribute('data-media-id')) === idStr) matchIndex = i;
      });
      if (matchIndex < 0) return false;
      show(matchIndex);
      return true;
    }

    function openLightbox() {
      if (!lightbox || !imgs.length) return;
      // Move to <body> so theme transforms/overflow never clip the overlay
      if (lightbox.parentElement !== document.body) {
        document.body.appendChild(lightbox);
      }
      var overlayColor = getComputedStyle(root).getPropertyValue('--zava-lightbox-bg').trim();
      if (overlayColor) {
        lightbox.style.setProperty('--zava-lightbox-bg', overlayColor);
      } else {
        lightbox.style.setProperty('--zava-lightbox-bg', 'rgba(0, 0, 0, 0.9)');
      }
      lightbox.hidden = false;
      document.documentElement.classList.add('zava-lightbox-open');
      syncLightbox();
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.hidden = true;
      document.documentElement.classList.remove('zava-lightbox-open');
      if (lightbox.parentElement === document.body && gallery) {
        gallery.appendChild(lightbox);
      }
    }

    function syncLightbox() {
      if (!lightbox || lightbox.hidden) return;
      var active = imgs[current];
      if (!active) return;
      var lbImg = lightbox.querySelector('[data-zava-lightbox-img]');
      var counter = lightbox.querySelector('[data-zava-lightbox-counter]');
      var lbThumbs = lightbox.querySelector('[data-zava-lightbox-thumbs]');
      if (lbImg) {
        lbImg.src = active.getAttribute('data-full-src') || active.src;
        lbImg.alt = active.alt || '';
      }
      if (counter) counter.textContent = (current + 1) + ' / ' + imgs.length;
      if (lbThumbs && !lbThumbs.children.length) {
        imgs.forEach(function (img, i) {
          var li = document.createElement('li');
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'zava-lightbox__thumb' + (i === current ? ' is-active' : '');
          btn.setAttribute('data-index', String(i));
          btn.setAttribute('aria-label', 'Image ' + (i + 1));
          var thumbImg = document.createElement('img');
          thumbImg.src = img.src;
          thumbImg.alt = '';
          btn.appendChild(thumbImg);
          btn.addEventListener('click', function () { show(i); });
          li.appendChild(btn);
          lbThumbs.appendChild(li);
        });
      } else if (lbThumbs) {
        Array.prototype.forEach.call(lbThumbs.querySelectorAll('.zava-lightbox__thumb'), function (btn, i) {
          btn.classList.toggle('is-active', i === current);
        });
      }
    }

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        show(Number(btn.getAttribute('data-zava-gallery-thumb')));
      });
    });

    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });

    if (lightbox) {
      if (zoom) zoom.addEventListener('click', openLightbox);
      if (stage) {
        stage.addEventListener('click', function (e) {
          if (e.target.closest('.zava-pdp-gallery__arrow, .zava-pdp-gallery__wishlist, .zava-pdp-gallery__zoom')) return;
          openLightbox();
        });
        stage.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            openLightbox();
          }
        });
      }
      lightbox.querySelectorAll('[data-zava-lightbox-close]').forEach(function (el) {
        el.addEventListener('click', closeLightbox);
      });
      var lbPrev = lightbox.querySelector('[data-zava-lightbox-prev]');
      var lbNext = lightbox.querySelector('[data-zava-lightbox-next]');
      if (lbPrev) lbPrev.addEventListener('click', function () { show(current - 1); });
      if (lbNext) lbNext.addEventListener('click', function () { show(current + 1); });
      document.addEventListener('keydown', function (e) {
        if (lightbox.hidden) return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowLeft') show(current - 1);
        if (e.key === 'ArrowRight') show(current + 1);
      });
    } else if (zoom) {
      zoom.addEventListener('click', function () {
        var active = imgs[current];
        if (active) window.open(active.getAttribute('data-full-src') || active.src, '_blank');
      });
    }

    root._zavaShowGalleryByMediaId = showByMediaId;
    root._zavaShowGallery = show;
  }

  function initTabs(root) {
    var tabs = root.querySelector('[data-zava-tabs]');
    if (!tabs) return;

    var btns = tabs.querySelectorAll('[data-zava-tab]');
    var panels = tabs.querySelectorAll('[data-zava-panel]');

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-zava-tab');
        btns.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          var match = panel.getAttribute('data-zava-panel') === id;
          panel.classList.toggle('is-active', match);
          if (match) panel.removeAttribute('hidden');
          else panel.setAttribute('hidden', '');
        });
      });
    });
  }

  function initQty(root) {
    var input = root.querySelector('[data-zava-qty-input]');
    if (!input) return;
    var minus = root.querySelector('[data-zava-qty-minus]');
    var plus = root.querySelector('[data-zava-qty-plus]');

    if (minus) {
      minus.addEventListener('click', function () {
        input.value = Math.max(1, Number(input.value || 1) - 1);
      });
    }
    if (plus) {
      plus.addEventListener('click', function () {
        input.value = Number(input.value || 1) + 1;
      });
    }
  }

  function parseJson(el) {
    if (!el || !el.textContent) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function formatMoney(cents, moneyFormat) {
    var value = Number(cents);
    if (isNaN(value)) value = 0;

    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(value, moneyFormat || undefined);
    }

    var format = moneyFormat || 'Rs.{{amount}}';
    var amount = (value / 100).toFixed(2);
    var amountNoDecimals = String(Math.round(value / 100));
    var amountWithComma = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function initVariants(root) {
    var form = root.querySelector('[data-zava-product-form]');
    var jsonEl = root.querySelector('[data-zava-product-json]');
    if (!form || !jsonEl) return;

    var product = parseJson(jsonEl);
    if (!product || !product.variants) return;

    var variantMediaMap = parseJson(root.querySelector('[data-zava-variant-media]')) || {};
    var moneyFormat = parseJson(root.querySelector('[data-zava-money-format]')) ||
      (window.Shopify && Shopify.money_format) ||
      'Rs.{{amount}}';

    var variantInput = form.querySelector('[data-zava-variant-id]');
    var priceEl = root.querySelector('[data-zava-price]');
    var skuEl = root.querySelector('[data-zava-sku]');
    var addBtn = form.querySelector('[data-zava-add-to-cart]');
    var optionInputs = form.querySelectorAll('[data-zava-option-input]');

    function getSelectedOptions() {
      var options = [];
      product.options.forEach(function (_, i) {
        var input = form.querySelector('[data-zava-option-input="' + i + '"]:checked') ||
          form.querySelector('select[data-zava-option-input="' + i + '"]');
        if (input) options.push(input.value);
      });
      return options;
    }

    function syncOptionActiveStates() {
      form.querySelectorAll('.zava-pdp-size, .zava-pdp-swatch').forEach(function (label) {
        var input = label.querySelector('input[type="radio"]');
        if (!input) return;
        label.classList.toggle('is-active', input.checked);
      });
    }

    function findVariant() {
      var selected = getSelectedOptions();
      if (selected.length !== product.options.length) return null;
      return product.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      }) || null;
    }

    function updateGalleryImage(variant) {
      if (!variant) return;
      var mediaId = variantMediaMap[String(variant.id)];
      if (mediaId == null && variant.featured_media) mediaId = variant.featured_media.id;
      if (mediaId == null && variant.featured_image) mediaId = variant.featured_image.id;

      if (typeof root._zavaShowGalleryByMediaId === 'function' && mediaId != null) {
        if (root._zavaShowGalleryByMediaId(mediaId)) return;
      }

      // Fallback: match by featured image filename/path
      if (!variant.featured_image || !variant.featured_image.src) return;
      var target = String(variant.featured_image.src).split('?')[0].replace(/^https?:/, '');
      var imgs = root.querySelectorAll('[data-zava-gallery-img]');
      for (var i = 0; i < imgs.length; i++) {
        var src = (imgs[i].getAttribute('data-full-src') || imgs[i].getAttribute('src') || '')
          .split('?')[0]
          .replace(/^https?:/, '');
        if (src && (src.indexOf(target) !== -1 || target.indexOf(src) !== -1 || pathsOverlap(src, target))) {
          if (typeof root._zavaShowGallery === 'function') root._zavaShowGallery(i);
          return;
        }
      }
    }

    function pathsOverlap(a, b) {
      var fileA = a.split('/').pop();
      var fileB = b.split('/').pop();
      if (!fileA || !fileB) return false;
      // Shopify may append _1200x etc. before extension
      var baseA = fileA.replace(/_\d+x(\d+)?(?=\.)/g, '').replace(/\.[^.]+$/, '');
      var baseB = fileB.replace(/_\d+x(\d+)?(?=\.)/g, '').replace(/\.[^.]+$/, '');
      return baseA === baseB || fileA.indexOf(baseB) === 0 || fileB.indexOf(baseA) === 0;
    }

    function updateUrl(variant) {
      if (!variant || !window.history || !window.history.replaceState) return;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* ignore */ }
    }

    function updateVariant() {
      syncOptionActiveStates();

      var variant = findVariant();
      if (!variant) return;

      if (variantInput) {
        variantInput.value = variant.id;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      product.options.forEach(function (_, i) {
        var checked = form.querySelector('[data-zava-option-input="' + i + '"]:checked') ||
          form.querySelector('select[data-zava-option-input="' + i + '"]');
        var label = root.querySelector('[data-zava-option-label="' + i + '"]');
        if (label && checked) label.textContent = checked.value;
      });

      if (priceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceEl.innerHTML =
            '<s class="zava-pdp-info__compare">' + formatMoney(variant.compare_at_price, moneyFormat) + '</s>' +
            '<span class="zava-pdp-info__sale">' + formatMoney(variant.price, moneyFormat) + '</span>';
        } else {
          priceEl.innerHTML = '<span>' + formatMoney(variant.price, moneyFormat) + '</span>';
        }
      }

      if (skuEl) skuEl.textContent = variant.sku || '';

      if (addBtn) {
        addBtn.disabled = !variant.available;
        var labelEl = addBtn.querySelector('[data-zava-add-label]');
        if (labelEl) {
          labelEl.textContent = variant.available
            ? (addBtn.getAttribute('data-label-available') || 'ADD TO CART')
            : (addBtn.getAttribute('data-label-sold') || 'SOLD OUT');
        }
      }

      updateGalleryImage(variant);
      updateUrl(variant);
    }

    if (addBtn) {
      var labelEl = addBtn.querySelector('[data-zava-add-label]');
      addBtn.setAttribute('data-label-available', labelEl ? labelEl.textContent.trim() : 'ADD TO CART');
      addBtn.setAttribute('data-label-sold', 'SOLD OUT');
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', updateVariant);
    });

    // Sync price, image, availability for the initially selected size/color
    updateVariant();
  }

  function initTrustSwipe() {
    var rows = document.querySelectorAll('[class*="ai-zava-benefits-row-"], [data-zava-trust-scroll]');
    if (!rows.length) return;

    var mobile = window.matchMedia('(max-width: 749px)');

    function apply(on) {
      rows.forEach(function (row) {
        var cards = row.querySelectorAll('[class*="ai-zava-benefit-card-"], .zava-trust-row__card');
        if (on) {
          row.style.setProperty('display', 'flex', 'important');
          row.style.setProperty('flex-wrap', 'nowrap', 'important');
          row.style.setProperty('overflow-x', 'auto', 'important');
          row.style.setProperty('overflow-y', 'hidden', 'important');
          row.style.setProperty('width', '100%', 'important');
          row.style.setProperty('max-width', '100%', 'important');
          row.style.setProperty('-webkit-overflow-scrolling', 'touch');
          for (var i = 0; i < cards.length; i++) {
            cards[i].style.setProperty('flex', '0 0 78vw', 'important');
            cards[i].style.setProperty('width', '78vw', 'important');
            cards[i].style.setProperty('min-width', '240px', 'important');
            cards[i].style.setProperty('max-width', '280px', 'important');
          }
        } else {
          row.removeAttribute('style');
          for (var j = 0; j < cards.length; j++) cards[j].removeAttribute('style');
        }
      });
    }

    apply(mobile.matches);
    if (mobile.addEventListener) {
      mobile.addEventListener('change', function (e) { apply(e.matches); });
    } else if (mobile.addListener) {
      mobile.addListener(function (e) { apply(e.matches); });
    }
  }

  function boot() {
    document.querySelectorAll('[data-zava-pdp]').forEach(function (root) {
      initGallery(root);
      initTabs(root);
      initQty(root);
      initVariants(root);
    });
    initTrustSwipe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
